import "./Projects.css";

function Projects() {
  const videos = [
    "/videos/video1.mp4",
    "/videos/video2.mp4",
    "/videos/video3.mp4",
    "/videos/video4.mp4",
  ];

  return (
    <section className="projects-section">
      <div className="projects-container">
        <span className="projects-tag">MY WORK</span>

        <h1>Video Projects</h1>

        <p className="projects-desc">
          A collection of cinematic work, product videos, and creative storytelling projects.
        </p>

        <div className="video-grid">
          {videos.map((video, index) => (
            <div className="video-card" key={index}>
              <video
                src={video}
                controls
                muted
                loop
                className="video-player"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Projects;